import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";

export default function Specification(props) {
  const [engine, setEngine] = useState("");
  const [maxPower, setMaxPower] = useState("");
  const [maxTorque, setMaxTorque] = useState("");
  const [mileage, setMileage] = useState("");
  const [driveTrain, setDriveTrain] = useState("");

  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [wheelbase, setWheelbase] = useState("");
  const [groundClearance, setGroundClearance] = useState("");
  const [kerbWeight, setKerbWeight] = useState("");

  const [doors, setDoors] = useState("");
  const [seatingCapacity, setSeatingCapacity] = useState("");
  const [rows, setRows] = useState("");
  const [bootspace, setBootspace] = useState("");
  const [fuelTankCapacity, setFuelTankCapacity] = useState("");

  const [frontSuspension, setFrontSuspension] = useState("");
  const [rearSuspension, setRearSuspension] = useState("");
  const [frontbrakeType, setFrontBrakeType] = useState("");
  const [rearBrakeType, setRearBrakeType] = useState("");
  const [minTurningRadius, setMinTurningRadius] = useState("");
  const [steeringType, setSteeringType] = useState("");
  const [wheels, setWheels] = useState("");
  const [spareWheel, setSpareWheel] = useState("");
  const [frontTyres, setFrontTyres] = useState("");
  const [rearTyres, setRearTyres] = useState("");

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (props.client.oldCarId !== "") {
      props.addSpecification(
        props.login.token,
        props.login.user_id,
        props.client.oldCarId,
        engine,
        maxPower,
        maxTorque,
        mileage,
        driveTrain,
        length,
        width,
        height,
        wheelbase,
        groundClearance,
        kerbWeight,
        doors,
        seatingCapacity,
        rows,
        bootspace,
        fuelTankCapacity,
        frontSuspension,
        rearSuspension,
        frontbrakeType,
        rearBrakeType,
        minTurningRadius,
        steeringType,
        wheels,
        spareWheel,
        frontTyres,
        rearTyres
      );
      navigate("/feature");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginTop: "80px",
        marginBottom: "40px",
        fontFamily: "sans-serif",
      }}
    >
      <div
        style={{
          width: "95%",
          maxWidth: "850px",
          background: "#fff",
          padding: "25px",
          borderRadius: "10px",
          boxShadow: "0 0 15px rgba(0,0,0,0.1)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontWeight: "700",
            color: "#cf2230",
            marginBottom: "25px",
            fontSize: "22px",
          }}
        >
          SPECIFICATIONS
        </h2>

        <form onSubmit={handleSubmit}>
          {/* ================= ENGINE ================== */}
          <div style={{ fontWeight: 700, marginBottom: 10 }}>Engine & Transmission</div>
          <div style={gridStyle}>
            {input("Engine (in cc)", engine, setEngine)}
            {input("Max Power (bhp@rpm)", maxPower, setMaxPower)}
            {input("Max Torque (Nm@rpm)", maxTorque, setMaxTorque)}
            {input("Mileage (ARAI)", mileage, setMileage)}

            <select
              value={driveTrain}
              onChange={(e) => setDriveTrain(e.target.value)}
              style={selectStyle}
            >
              <option value="">Drive Train</option>
              <option value="fwd">FWD</option>
              <option value="rwd">RWD</option>
              <option value="awd">AWD</option>
              <option value="4">4X4</option>
              <option value="2">2WD</option>
            </select>
          </div>

          {/* ================= DIMENSIONS ================== */}
          <div style={sectionHeading}>Dimensions & Weight</div>
          <div style={gridStyle}>
            {input("Length", length, setLength)}
            {input("Width", width, setWidth)}
            {input("Height", height, setHeight)}
            {input("Wheelbase", wheelbase, setWheelbase)}
            {input("Ground Clearance", groundClearance, setGroundClearance)}
            {input("Kerb Weight", kerbWeight, setKerbWeight)}
          </div>

          {/* ================= CAPACITY ================== */}
          <div style={sectionHeading}>Capacity</div>
          <div style={gridStyle}>
            {input("Doors", doors, setDoors)}
            {input("Seating Capacity", seatingCapacity, setSeatingCapacity)}
            {input("No of Rows", rows, setRows)}
            {input("Bootspace", bootspace, setBootspace)}
            {input("Fuel Tank Capacity", fuelTankCapacity, setFuelTankCapacity)}
          </div>

          {/* ================= SUSPENSION ================== */}
          <div style={sectionHeading}>
            Suspensions, Brakes, Steering & Tyres
          </div>
          <div style={gridStyle}>
            {input("Front Suspension", frontSuspension, setFrontSuspension)}
            {input("Rear Suspension", rearSuspension, setRearSuspension)}
            {input("Front Brake Type", frontbrakeType, setFrontBrakeType)}
            {input("Rear Brake Type", rearBrakeType, setRearBrakeType)}
            {input("Min Turning Radius", minTurningRadius, setMinTurningRadius)}
            {input("Steering Type", steeringType, setSteeringType)}
            {input("Wheels", wheels, setWheels)}
            {input("Spare Wheel", spareWheel, setSpareWheel)}
            {input("Front Tyres", frontTyres, setFrontTyres)}
            {input("Rear Tyres", rearTyres, setRearTyres)}
          </div>

          {/* ================= BUTTONS ================== */}
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button style={btnStyle} type="submit">Skip</button>
            <button style={{ ...btnStyle, marginLeft: "10px" }} type="submit">
              Next
            </button>
          </div>
        </form>
      </div>

      <LoaderCon />

      <Snackbar1
        open={props.snackbar.response_received}
        onClose={props.close_snack_bar}
        message={props.snackbar.message}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />
    </div>
  );
}

/* ---------- INTERNAL STYLES ---------- */
const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
  gap: "15px",
  marginBottom: "25px",
};

const inputStyle = {
  padding: "10px",
  border: "1px solid #ddd",
  borderRadius: "6px",
  fontSize: "14px",
};

const selectStyle = {
  ...inputStyle,
};

const btnStyle = {
  background: "#cf2230",
  padding: "10px 25px",
  borderRadius: "6px",
  border: "none",
  color: "#fff",
  fontWeight: 600,
  cursor: "pointer",
};

const sectionHeading = {
  fontWeight: 700,
  marginBottom: 10,
};

function input(label, val, setVal) {
  return (
    <input
      placeholder={label}
      value={val}
      style={inputStyle}
      onChange={(e) => setVal(e.target.value)}
    />
  );
}
